export const topmenu = {
  signin: "Log in",
  register: "Sign up",

  home: "Home",
  about: "About onelink.to",
  about_small: "About",
  my_onelinks: "My Onelinks",
  my_onelinks_short: "Onelinks",
  my_account: "My Account",
  news: "News",
  pricing: "Pricing",
  support: "Support",
  contact: "Contact Us",

  button_sign_out: "Log out",
  button_account_settings: "Account Settings",
  subscription_cancelled: "Subscription cancelled",
  button_user_settings: "User Settings",
  continue_registration: "Continue Registration",
  button_upgrade_plan: "Upgrade Plan",
  button_manage_access: "Manage Access",
  button_manage_cookies: "Manage Cookies",
};
